module.exports = __webpack_public_path__ + "img/yaourtvert_off.5128d106.gif";